<template>
  <v-card elevation="0" rounded="lg" class="pa-2 pt-2">
    <div class="d-flex flex-wrap align-center justify-space-between px-2 mb-2">
      <h6 class="text-subtitle-1 font-weight-bold mb-0">Reembolsos Pendentes por Evento</h6>
      <div v-if="!loading && refunds" class="d-flex flex-wrap gap-4 text-caption">
        <span>
          <strong>{{ refunds.summary?.count | number }}</strong> pedidos
        </span>
        <span>
          <strong>{{ refunds.summary?.amount | currency }}</strong> em valor
        </span>
      </div>
    </div>

    <p class="text-caption text--secondary px-2 mb-2">
      Pedidos de reembolso em aberto de eventos a partir do início do período filtrado (incluindo futuros).
    </p>

    <v-skeleton-loader v-if="loading" type="table" />
    <v-data-table
      v-else
      :headers="headers"
      :items="refunds?.events || []"
      dense
      hide-default-footer
      :items-per-page="10"
      no-data-text="Nenhum pedido de reembolso pendente para eventos neste período"
    >
      <template v-slot:item.name="{ item }">
        <div class="d-flex align-center py-1">
          <div class="ml-n2">
            <v-img
              v-if="item.cover"
              :src="item.cover"
              :aspect-ratio="16 / 9"
              height="48"
              :width="48 * (16 / 9)"
              class="mr-2 rounded"
            />
          </div>
          <div>
            <div class="font-weight-medium">{{ item.name }}</div>
            <div class="text-caption text--secondary">
              {{ item.organizationName }} · {{ item.date | date("DD/MM/YYYY") }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item.requestCount="{ item }">
        {{ item.requestCount | number }}
      </template>
      <template v-slot:item.totalAmount="{ item }">
        <span class="font-weight-bold">{{ item.totalAmount | currency }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: "DashboardRefunds",
  props: {
    refunds: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      headers: [
        { text: "Evento", value: "name", sortable: false },
        {
          text: "Pedidos",
          value: "requestCount",
          align: "end",
          sortable: false,
        },
        {
          text: "Valor",
          value: "totalAmount",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
};
</script>
